import { FC, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Result } from 'antd';
import { useDispatch } from 'react-redux';

import { storeName } from '../../redux/models/layout.model';

import './styles.scss';

const NotFoundPage: FC = () => {
  const dispatch = useDispatch()[storeName];

  useEffect(() => {
    dispatch.setLoading(false);
  }, []);

  return (
    <div className="bds-not-found-page">
      <Helmet title="404" />
      <Result status="404" title="404" subTitle="Sorry, the page you visited does not exist." />
    </div>
  );
};

export default NotFoundPage;
